import React from 'react';
import { useNotification as useNotificationContext } from '../context/NotificationContext';
// Re-export the hook for easier imports
export const useNotification = useNotificationContext;